// firebase.js — React frontend only

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Copy these values from Firebase Console > Project Settings > SDK setup
const firebaseConfig = {
  apiKey: "86HzDQKFcd06QqMm97mcQbdb0guwV8o2rlhP8p4j",
  authDomain: "jewellery-erp-b94ab.firebaseapp.com",
  databaseURL: "https://jewellery-erp-b94ab-default-rtdb.firebaseio.com",
  projectId: "jewellery-erp-b94ab",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
